import { useGlobalStore } from "controller/store/globalStore";

export const getCredentialStorage = () => {
  return useGlobalStore.getState();
};

export const getAccessToken = () => {
  const globalStore = getCredentialStorage();
  return globalStore.accessToken || "";
};

export const getMspId = () => {
  const globalStore = getCredentialStorage();
  return globalStore?.mspId || "";
};

export const getResourceName = () => {
  const globalStore = getCredentialStorage();
  return globalStore?.name || "";
};

export const getEmail = () => {
  const globalStore = getCredentialStorage();
  return globalStore?.email || "";
};

export const getProfilePictureUrl = () => {
  const globalStore = getCredentialStorage();
  return globalStore?.profilePictureUrl || "";
};

export const getRole = () => {
  const globalStore = getCredentialStorage();
  return globalStore?.role || "";
};

export const getPermission = () => {
  const globalStore = getCredentialStorage();
  return globalStore?.permissions || "";
};

export const getResourceId = () => {
  const globalStore = getCredentialStorage();
  return globalStore?.resourceId || "";
};

export const getTimeZone = () => {
  const globalStore = getCredentialStorage();
  return globalStore?.timezone || "";
};

/**
 * @deprecated This function is deprecated with Logto integration
 * Cookie-based token management is replaced by Logto SDK
 * This function is kept for backward compatibility during migration
 */
export const cookieGenerator = (aud: string, refreshToken: string) => {
  console.warn("cookieGenerator is deprecated - token management is now handled by Logto SDK");
  const d = new Date();
  const newAud = `${aud}`.replace("-", "");
  const vanityDomain = new URL(window.location.origin);
  d.setTime(d.getTime() + 29 * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();

  return (
    `fe_refresh_${newAud}` +
    "=" +
    refreshToken +
    ";expires=" +
    expires +
    `;path=/;domain=${
      import.meta.env.MODE !== "development"
        ? vanityDomain?.hostname
        : "localhost"
    }`
  );
};
